module.exports = __webpack_public_path__ + "static/media/tablet.f9148971.jpg";